module.exports = __webpack_public_path__ + "static/netflix-0b2b52a813a27b93438b69d617390faa.png";